module.exports = __webpack_public_path__ + "img/pixing_xc4.23bfbfa9.jpg";